<template>
  <a-table
    :columns="table.columns"
    :loading="table.loading"
    :data-source="table.data"
    :pagination="false"
    rowKey="webId"
    :scroll="{ x: 1200 }"
  >
    <span slot="propertyType" slot-scope="propertyType">
      {{ propertyType | propertyTypeText }}
    </span>
    <span slot="auditStatus" slot-scope="auditStatus">
      <a-badge
        v-if="auditStatus != null"
        :status="auditStatus | statusTypeFilter"
        :text="auditStatus | statusFilter"
      />
    </span>
  </a-table>
</template>

<script>
const columns = [
  {
    title: "权证编号",
    dataIndex: "certificateNumber",
    width: 280,
  },
  {
    title: "权证类型",
    dataIndex: "propertyType",
    width: 100,
    scopedSlots: { customRender: "propertyType" },
  },
  {
    title: "权利人名称",
    dataIndex: "obligeeName",
    width: 280,
  },
  {
    title: "提交时间",
    dataIndex: "createTime",
    width: 200,
  },
  {
    title: "状态",
    dataIndex: "auditStatus",
    width: 180,
    scopedSlots: { customRender: "auditStatus" },
  },
];
const statusMap = {
  1: {
    status: "warning",
    text: "编辑中",
  },
  2: {
    status: "processing",
    text: "审核中",
  },
  3: {
    status: "success",
    text: "审核通过",
  },
};
const propertyType = {
  1: "产权",
  2: "使用权",
  3: "其他",
};
import { listWarrantByWebId } from "@/api/property/Property.js";
export default {
  props: {
    selectRightList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      table: {
        data: [],
        loading: false,
        columns,
      },
    };
  },
  mounted() {
    this.listWarrant();
  },
  filters: {
    statusFilter(type) {
      return statusMap[type].text;
    },
    statusTypeFilter(type) {
      return statusMap[type].status;
    },
    propertyTypeText(type) {
      return propertyType[type] || "-";
    },
  },
  methods: {
    listWarrant() {
      this.table.loading = true;
      listWarrantByWebId({
        webId: this.selectRightList,
      }).then((res) => {
        this.table.data = res.data;
        this.table.loading = false;
      });
    },

    //判断权证是否全是审核通过状态
    validWarrantAuditStatus(){
      return this.table.data.some(item => Number(item.auditStatus) !== 3)
    }
  },
};
</script>

<style>
</style>